import { Wrench, Search, Cog, Settings, LifeBuoy, RefreshCw } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { PageHero, CTABand, SectionHead } from "@/components/Bits";

const SERVICES = [
  { icon: Settings, t: "Manutenção Preventiva", d: "Planos periódicos para prolongar a vida útil e evitar paradas." },
  { icon: Wrench, t: "Manutenção Corretiva", d: "Diagnóstico e reparo com agilidade para reduzir tempo de parada." },
  { icon: Search, t: "Diagnóstico Técnico", d: "Avaliação de desempenho, consumo e falhas do sistema." },
  { icon: Cog, t: "Instalação & Comissionamento", d: "Montagem, partida e ajuste fino do equipamento." },
  { icon: RefreshCw, t: "Retrofit", d: "Modernização de sistemas existentes e troca de fluidos." },
  { icon: LifeBuoy, t: "Suporte & Peças", d: "Fornecimento de peças de reposição e suporte remoto." },
];

export default function Assistencia() {
  const { openQuote } = useSite();
  return (
    <div>
      <PageHero eyebrow="Assistência Técnica" title="Assistência é o nosso diferencial"
        subtitle="Manutenção, diagnóstico, instalação, retrofit e peças. Também estruturamos o pós-venda por número de série, com histórico e QR Code no equipamento."
        image="https://images.unsplash.com/photo-1581092163144-b7ae3c00adbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600">
        <div className="mt-9 flex flex-wrap gap-3">
          <Button data-testid="assist-request-button" onClick={() => openQuote({ equipment_type: "Assistência Técnica", source: "assistencia" })}
            className="rounded-none bg-[#FF5500] px-8 py-6 text-base font-bold hover:bg-[#CC4400]">Solicitar Assistência</Button>
        </div>
      </PageHero>
      <section className="mx-auto max-w-[1400px] px-4 py-20 lg:px-8">
        <SectionHead eyebrow="O que fazemos" title="Serviços de assistência" />
        <div className="grid grid-cols-1 gap-px border border-[#27272A] bg-[#27272A] sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => (
            <div key={s.t} className="bg-[#0A0A0B] p-8 transition-colors duration-200 hover:bg-[#151618]">
              <s.icon className="h-8 w-8 text-[#007AFF]" />
              <h3 className="font-heading mt-4 text-lg font-bold text-white">{s.t}</h3>
              <p className="mt-2 text-sm text-[#A1A1AA]">{s.d}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="border-t border-[#27272A] bg-[#0A0A0B]">
        <div className="mx-auto max-w-[1400px] px-4 py-20 lg:px-8">
          <SectionHead eyebrow="Pós-venda" title="Cadastro e rastreabilidade do equipamento" sub="Cada equipamento fabricado terá cadastro por número de série: cliente, modelo, data, garantia, histórico de manutenção e peças — acessível por QR Code." />
          <div className="grid grid-cols-2 gap-px border border-[#27272A] bg-[#27272A] md:grid-cols-4">
            {["Nº de série", "Garantia", "Histórico de manutenção", "QR Code no equipamento"].map((t) => (
              <div key={t} className="bg-[#0A0A0B] p-6"><p className="text-sm font-medium text-white">{t}</p></div>
            ))}
          </div>
          <div className="mt-6">
            <Link to="/pos-venda" data-testid="assist-posvenda-link">
              <Button variant="outline" className="rounded-none border-[#3f3f46] bg-transparent px-6 py-5 font-bold text-white hover:bg-[#1E1F22] hover:text-white">Consultar equipamento por nº de série</Button>
            </Link>
          </div>
        </div>
      </section>
      <CTABand title="Precisa de assistência agora?" text="Solicite atendimento e nossa equipe entra em contato." />
    </div>
  );
}
